import { Image, Skeleton } from 'antd';
import { VFC } from 'react';
import { useFileLink } from 'hooks/api/enmon-tools/files/useFileLink';
import { SerializedFile } from '@enmon/commons/lib/enmon';
import { FALLBACK_IMAGE_URL } from '../../consts/common';

const PHOTO_SIZE = '100%' as const;
const SKELETON_IMAGE_SIZE = 150 as const;
const IMAGE_SETTINGS = { height: PHOTO_SIZE, width: PHOTO_SIZE, objectFit: 'cover' } as const;

export const InventoryMeterImage: VFC<{ file?: SerializedFile }> = ({ file }) => {
  const { data, isLoading, error } = useFileLink(file);

  if (isLoading) return <Skeleton.Image style={{ height: SKELETON_IMAGE_SIZE, width: SKELETON_IMAGE_SIZE }} />;
  if (error || !data?.link) {
    return (
      <Image alt={error instanceof Error ? error.message : undefined} src={FALLBACK_IMAGE_URL} style={IMAGE_SETTINGS} />
    );
  }

  return <Image alt="Inventory Meter Photo" fallback={FALLBACK_IMAGE_URL} src={data.link} style={IMAGE_SETTINGS} />;
};
